const APROVARPLANOPLAN_FETCH_REQUEST = 'APROVARPLANOPLAN_FETCH_REQUEST'
const APROVARPLANOPLAN_FETCH_SUCCESS = 'APROVARPLANOPLAN_FETCH_SUCCESS'
const APROVARPLANOPLAN_FETCH_FAILURE = 'APROVARPLANOPLAN_FETCH_FAILURE'

const APROVARPLANOPLAN_USERS_REQUEST = 'APROVARPLANOPLAN_USERS_REQUEST'
const APROVARPLANOPLAN_USERS_SUCCESS = 'APROVARPLANOPLAN_USERS_SUCCESS'
const APROVARPLANOPLAN_USERS_FAILURE = 'APROVARPLANOPLAN_USERS_FAILURE'

const APROVARPLANOPLAN_INTEGRACAO_REQUEST = 'APROVARPLANOPLAN_INTEGRACAO_REQUEST'
const APROVARPLANOPLAN_INTEGRACAO_SUCCESS = 'APROVARPLANOPLAN_INTEGRACAO_SUCCESS'
const APROVARPLANOPLAN_INTEGRACAO_FAILURE = 'APROVARPLANOPLAN_INTEGRACAO_FAILURE'

const APROVARPLANOPLAN_BUSCAR_DESTINO_REQUEST = 'APROVARPLANOPLAN_BUSCAR_DESTINO_REQUEST'
const APROVARPLANOPLAN_BUSCAR_DESTINO_SUCCESS = 'APROVARPLANOPLAN_BUSCAR_DESTINO_SUCCESS'
const APROVARPLANOPLAN_BUSCAR_DESTINO_FAILURE = 'APROVARPLANOPLAN_BUSCAR_DESTINO_FAILURE'

const APROVARPLANOPLAN_VALIDAR_URL_REQUEST = 'APROVARPLANOPLAN_VALIDAR_URL_REQUEST'
const APROVARPLANOPLAN_VALIDAR_URL_SUCCESS = 'APROVARPLANOPLAN_VALIDAR_URL_SUCCESS'
const APROVARPLANOPLAN_VALIDAR_URL_FAILURE = 'APROVARPLANOPLAN_VALIDAR_URL_FAILURE'

const APROVARPLANOPLAN_GRAVAR_DESTINO_REQUEST = 'APROVARPLANOPLAN_GRAVAR_DESTINO_REQUEST'
const APROVARPLANOPLAN_GRAVAR_DESTINO_SUCCESS = 'APROVARPLANOPLAN_GRAVAR_DESTINO_SUCCESS'
const APROVARPLANOPLAN_GRAVAR_DESTINO_FAILURE = 'APROVARPLANOPLAN_GRAVAR_DESTINO_FAILURE'

const APROVARPLANOPLAN_SUBMIT_REQUEST = 'APROVARPLANOPLAN_SUBMIT_REQUEST'
const APROVARPLANOPLAN_SUBMIT_SUCCESS = 'APROVARPLANOPLAN_SUBMIT_SUCCESS'
const APROVARPLANOPLAN_SUBMIT_FAILURE = 'APROVARPLANOPLAN_SUBMIT_FAILURE'

const APROVARPLANOPLAN_CLEAR = 'APROVARPLANOPLAN_CLEAR'

const initialState = {
  loading: false,
  loadingUsers: false,
  loadingIntegracao: false,
  loadingBuscarDestino: false,
  loadingValidarUrl: false,
  loadingGravarDestino: false,
  submitting: false,
  data: null,
  usuarios: [],
  integracao: null,
  destinoSalvo: null,
  urlValidada: null,
  error: null
}

export default function aprovarplanoplanReducer(state = initialState, action) {
  switch (action.type) {
    case APROVARPLANOPLAN_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case APROVARPLANOPLAN_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      }

    case APROVARPLANOPLAN_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case APROVARPLANOPLAN_USERS_REQUEST:
      return {
        ...state,
        loadingUsers: true,
        error: null
      }

    case APROVARPLANOPLAN_USERS_SUCCESS:
      return {
        ...state,
        loadingUsers: false,
        usuarios: action.payload,
        error: null
      }

    case APROVARPLANOPLAN_USERS_FAILURE:
      return {
        ...state,
        loadingUsers: false,
        error: action.payload
      }

    case APROVARPLANOPLAN_INTEGRACAO_REQUEST:
      return {
        ...state,
        loadingIntegracao: true,
        error: null
      }

    case APROVARPLANOPLAN_INTEGRACAO_SUCCESS:
      return {
        ...state,
        loadingIntegracao: false,
        integracao: action.payload,
        error: null
      }

    case APROVARPLANOPLAN_INTEGRACAO_FAILURE:
      return {
        ...state,
        loadingIntegracao: false,
        error: action.payload
      }

    case APROVARPLANOPLAN_BUSCAR_DESTINO_REQUEST:
      return {
        ...state,
        loadingBuscarDestino: true,
        error: null
      }

    case APROVARPLANOPLAN_BUSCAR_DESTINO_SUCCESS:
      return {
        ...state,
        loadingBuscarDestino: false,
        destinoSalvo: action.payload,
        error: null
      }

    case APROVARPLANOPLAN_BUSCAR_DESTINO_FAILURE:
      return {
        ...state,
        loadingBuscarDestino: false,
        error: action.payload
      }

    case APROVARPLANOPLAN_VALIDAR_URL_REQUEST:
      return {
        ...state,
        loadingValidarUrl: true,
        error: null
      }

    case APROVARPLANOPLAN_VALIDAR_URL_SUCCESS:
      return {
        ...state,
        loadingValidarUrl: false,
        urlValidada: action.payload,
        error: null
      }

    case APROVARPLANOPLAN_VALIDAR_URL_FAILURE:
      return {
        ...state,
        loadingValidarUrl: false,
        error: action.payload
      }

    case APROVARPLANOPLAN_GRAVAR_DESTINO_REQUEST:
      return {
        ...state,
        loadingGravarDestino: true,
        error: null
      }

    case APROVARPLANOPLAN_GRAVAR_DESTINO_SUCCESS:
      return {
        ...state,
        loadingGravarDestino: false,
        destinoSalvo: action.payload,
        error: null
      }

    case APROVARPLANOPLAN_GRAVAR_DESTINO_FAILURE:
      return {
        ...state,
        loadingGravarDestino: false,
        error: action.payload
      }

    case APROVARPLANOPLAN_SUBMIT_REQUEST:
      return {
        ...state,
        submitting: true,
        error: null
      }

    case APROVARPLANOPLAN_SUBMIT_SUCCESS:
      return {
        ...state,
        submitting: false,
        error: null
      }

    case APROVARPLANOPLAN_SUBMIT_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload
      }

    case APROVARPLANOPLAN_CLEAR:
      return initialState

    default:
      return state
  }
}

export {
  APROVARPLANOPLAN_FETCH_REQUEST,
  APROVARPLANOPLAN_FETCH_SUCCESS,
  APROVARPLANOPLAN_FETCH_FAILURE,
  APROVARPLANOPLAN_USERS_REQUEST,
  APROVARPLANOPLAN_USERS_SUCCESS,
  APROVARPLANOPLAN_USERS_FAILURE,
  APROVARPLANOPLAN_INTEGRACAO_REQUEST,
  APROVARPLANOPLAN_INTEGRACAO_SUCCESS,
  APROVARPLANOPLAN_INTEGRACAO_FAILURE,
  APROVARPLANOPLAN_BUSCAR_DESTINO_REQUEST,
  APROVARPLANOPLAN_BUSCAR_DESTINO_SUCCESS,
  APROVARPLANOPLAN_BUSCAR_DESTINO_FAILURE,
  APROVARPLANOPLAN_VALIDAR_URL_REQUEST,
  APROVARPLANOPLAN_VALIDAR_URL_SUCCESS,
  APROVARPLANOPLAN_VALIDAR_URL_FAILURE,
  APROVARPLANOPLAN_GRAVAR_DESTINO_REQUEST,
  APROVARPLANOPLAN_GRAVAR_DESTINO_SUCCESS,
  APROVARPLANOPLAN_GRAVAR_DESTINO_FAILURE,
  APROVARPLANOPLAN_SUBMIT_REQUEST,
  APROVARPLANOPLAN_SUBMIT_SUCCESS,
  APROVARPLANOPLAN_SUBMIT_FAILURE,
  APROVARPLANOPLAN_CLEAR
}